import React from 'react';
import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loadStart } from '../../redux/myDashboardSlice';
import { updateFilters } from '../../redux/transactionSlice';

import { Box, Typography } from '@mui/material';
import Filter from './filter';
import CategoryProgressCard from '../../components/dashboard/CategoryProgressCard';

function extractCategories(data) {
  if (!data || !data.groups) {
    return [];
  }

  const allCategories = [];

  data.groups.debit.forEach(group => {
    if (group.categories && Array.isArray(group.categories)) {
      group.categories.forEach(item => {
        if(item.category.goal > 0){
          const categoryWithSpent = {
            ...item.category, 
            spent: item.balance.total,
            month: Object.keys(item.balance)[0]
          };
          allCategories.push(categoryWithSpent);
      }
      });
    }
  });

  return allCategories;
}

const MyDashboard = () => {
  const dispatch = useDispatch();
  const result = useSelector(state => state.myDashboard.result);
  const shouldBeUpdated = useSelector(state => state.myDashboard.shouldBeUpdated);
  const lastUpdate = useSelector(state => state.myDashboard.lastUpdate);

  const loadStartAction = useCallback(() => dispatch(loadStart()), [dispatch]);
  const updateTransactionFilters = (newFilters) => dispatch(updateFilters(newFilters));

  const navigate = useNavigate();
  const categories = extractCategories(result);
  
  useEffect(() => {
    if (shouldBeUpdated || new Date(lastUpdate).getTime() + 1000 * 10 < new Date().getTime()) {
      loadStartAction();
    }

  }, [shouldBeUpdated, lastUpdate, loadStartAction]);

  if (!result.balance)
    return <div>No data</div>;

  return (
    <Box>
      <Typography variant="h4" component="h2" sx={{ 
        fontWeight: 700,
        color: '#1a1a1a',
        marginBottom: 3,
      }}>
        Orçamento por Categoria
      </Typography>
       <Filter></Filter>
      <Box sx={{ mt: 3 }}>
        {categories.map(category => (
          <CategoryProgressCard
            key={category.id}
            categoryId={category.id}
            name={category.name}
            spent={category.spent}
            goal={category.goal}
            month={category.month}
            updateTransactionFilters={updateTransactionFilters}
            navigate={navigate}
          />
        ))}
      </Box>
    </Box>
  );
};

export default MyDashboard;